import Cookies from 'js-cookie'
import { getWebSiteInfo, getHomeColumns } from '@/api/home'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    webInfo: null,
    homeColumns: null,
    downAction: false
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    TOGGLE_DOWNACTION: state => {
      state.downAction = !state.downAction
    },
    GET_WEBINFO: (state, data) => {
      state.webInfo = data
    },
    GET_HOMECOLUMNS: (state, data) => {
      state.homeColumns = data
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    toggleDownAction({ commit }) {
      commit('TOGGLE_DOWNACTION')
    },
    async getWebInfo({ commit }) {
      const { data: info } = await getWebSiteInfo()
      commit('GET_WEBINFO', info)
    },
    async getHomeColumns({ commit }) {
      const { data: columns } = await getHomeColumns()
      commit('GET_HOMECOLUMNS', columns.filter((item) => !!item.status))
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js